'use client';

import { useEffect, useState } from 'react';
import { BaseCarousel } from 'components/shared/Carousel/BaseCarousel';
import { carouselClassNames } from 'components/shared/Card/styles';
import { useBreakpoint } from 'hooks/useBreakpoints';
import { PropsWithChildrenAndClass } from 'types/sharedComponents';
import { ArticleGridProps } from 'libs/contentful/props';
import { cn } from 'utils/styles';

interface ArticleRowCarouselProps extends Pick<ArticleGridProps, 'color'>, PropsWithChildrenAndClass {
  totalItems: number;
}

const ArticleRowCarousel = ({ color, totalItems, children, className }: ArticleRowCarouselProps) => {
  const [isClient, setIsClient] = useState(false);
  const { isAboveSm } = useBreakpoint('sm');
  const responsiveThreshold = isAboveSm ? 4 : 1;

  useEffect(() => {
    setIsClient(true);
  }, []);

  const options = {
    breakpoints: {
      '(min-width: 750px)': { active: false },
    },
  };

  const slides = (
    <div className={cn('grid grid-flow-col auto-cols-[95%] sm:auto-cols-fr gap-x-2 sm:gap-x-8', className)}>
      {children}
    </div>
  );

  return isClient ? (
    <BaseCarousel
      totalItems={totalItems}
      carouselClassName={carouselClassNames(color)}
      carouselPaginationClassName="mt-8"
      carouselContentClassName="w-full"
      showPaginationThreshold={responsiveThreshold}
      carouselOpts={options}>
      {slides}
    </BaseCarousel>
  ) : (
    slides
  );
};

export default ArticleRowCarousel;
